module.exports = __webpack_public_path__ + "img/ajax-amsterdam-logo-icon.c54cab74.png";